import './styles.scss';

const Footer = ({ children }) => {
  return (
    <footer className="footer">
      <p>{children}</p>
    </footer>
  );
};

export default Footer;
